var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMiniMapCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "black",
    fillOpacity: 0.3,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2641 3.73592C10.0622 3.53403 9.73484 3.53403 9.53295 3.73592L6.99999 6.26888L4.46703 3.73592C4.26514 3.53403 3.93781 3.53403 3.73592 3.73592C3.53403 3.93781 3.53403 4.26514 3.73592 4.46703L6.26888 6.99999L3.73592 9.53295C3.53403 9.73484 3.53403 10.0622 3.73592 10.2641C3.93781 10.466 4.26514 10.466 4.46703 10.2641L6.99999 7.7311L9.53295 10.2641C9.73484 10.466 10.0622 10.466 10.2641 10.2641C10.466 10.0622 10.466 9.73484 10.2641 9.53295L7.7311 6.99999L10.2641 4.46703C10.466 4.26514 10.466 3.93781 10.2641 3.73592Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMiniMapCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/miniMapClose_icon.766cc0a4.svg";
export { ForwardRef as ReactComponent };